/*
Sai maheshwar 11/28/2022 3031450488 added error tooltip component
Sohel 06/03/2023 2700799562 Added Amount Format and Data Type Field
Sohel 06/03/2023 2700799562 Added Amount Format in Reports
Phanee 08/08/2023 2700799562 Added sortType and sortSeqNum field
*/

import React from 'react';
import {
  FormControl,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import {ErrorTooltip} from '../../../../../components/Tooltips';
export function getFields(unSelected) {
  const currField = unSelected.fieldName + unSelected.repositoryName;
  return {
    fieldLength: ({values = {}, touched = {}, errors = {}, setFieldValue}) => {
      return (
        <>
          <div key={currField} className={`format-field-length`}>
            <ErrorTooltip
              title={errors['fieldLength' + currField] ? errors['fieldLength' + currField] : ''}
            >
              <TextField
                margin="dense"
                type="number"
                variant="outlined"
                placeholder={`Enter field length`}
                InputLabelProps={{
                  shrink: true,
                }}
                name={'fieldLength' + currField}
                value={values['fieldLength' + currField]}
                // required
                onChange={(e) => {
                  setFieldValue('fieldLength' + currField, e.target.value);
                }}
                error={Boolean(errors['fieldLength' + currField])}
              />
            </ErrorTooltip>
            {/* <FormHelperText error style={{ position: "relative" }}>
              {errors["fieldLength" + currField]
                ? errors["fieldLength" + currField]
                : ""}
            </FormHelperText> */}
          </div>
        </>
      );
    },
    format: ({
      values = {},
      touched = {},
      errors = {},
      setFieldValue,
      dataType,
      dropDownData,
      disabled = false,
      rowData,
    }) => {
      const dropDownValues =
        rowData?.fieldType?.toLowerCase() === 'date' ?
          dropDownData?.DATE_FORMAT :
          rowData?.fieldType?.toLowerCase() === 'amount' ?
            dropDownData?.AMOUNT_FORMAT :
            rowData?.fieldType?.toLowerCase() === 'ssn' ?
              dropDownData?.SSN :
              rowData?.fieldType?.toLowerCase() === 'phone' ?
                dropDownData?.PHONE_FORMAT :
                [];
      return (
        <>
          <div key={currField} className="format-field">
            <ErrorTooltip title={errors['format' + currField] ? errors['format' + currField] : ''}>
              <FormControl margin="dense" variant="outlined" fullWidth className="mw-120">
                <Select
                  fullWidth
                  name={'dateFormat' + currField}
                  className="select-gender"
                  disabled={disabled}
                  value={values['dateFormat' + currField] || 'none'}
                  onChange={(e) => {
                    setFieldValue('dateFormat' + currField, e.target.value);
                  }}
                >
                  <MenuItem value="none" key="none" disabled>
                    <span className="defaultSelected">Select Any</span>
                  </MenuItem>
                  {dropDownValues?.length > 0 &&
                    dropDownValues?.map((sep) => (
                      <MenuItem value={sep.value} key={sep.key}>
                        {sep.value}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </ErrorTooltip>
          </div>
        </>
      );
    },
    amountFormat: ({
      values = {},
      touched = {},
      errors = {},
      setFieldValue,
      dataType,
      dropDownData,
      disabled = false,
    }) => {
      return (
        <>
          <div key={currField} className="format-field">
            <ErrorTooltip
              title={errors['amountType' + currField] ? errors['amountType' + currField] : ''}
            >
              <FormControl margin="dense" variant="outlined" fullWidth className="mw-120">
                <Select
                  fullWidth
                  name={'amountType' + currField}
                  className="select-gender"
                  disabled={disabled}
                  value={
                    disabled ?
                      'none' :
                      values['amountType' + currField] ?
                        values['amountType' + currField] :
                        'With $'
                  }
                  // defaultValue={disabled ? "none" : "With $"}
                  onChange={(e) => {
                    setFieldValue('amountType' + currField, e.target.value);
                  }}
                >
                  <MenuItem value="none" key="none" disabled>
                    <span className="defaultSelected">Select Any</span>
                  </MenuItem>
                  {dropDownData?.AMOUNT_TYPE &&
                    dropDownData?.AMOUNT_TYPE?.map((sep) => (
                      <MenuItem value={sep.value} key={sep.value}>
                        {sep.value}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </ErrorTooltip>
          </div>
        </>
      );
    },
    printSubTotal: ({
      values = {},
      touched = {},
      errors = {},
      setFieldValue,
      disabled = false,
      handlePrintTotal,
    }) => {
      return (
        <>
          <div key={currField} className="format-field">
            <ErrorTooltip
              title={errors['printSubTotal' + currField] ? errors['printSubTotal' + currField] : ''}
            >
              <FormControl margin="dense" variant="outlined" fullWidth>
                <Select
                  name={'printSubTotal' + currField}
                  className="select-gender"
                  disabled={disabled}
                  value={values['printSubTotal' + currField] || 'none'}
                  onChange={(e) => {
                    setFieldValue('printSubTotal' + currField, e.target.value)
                    const newValues = { ...values, ['printSubTotal' + currField]: e.target.value };
                    handlePrintTotal && handlePrintTotal(newValues);
                  }}
                >
                  <MenuItem value="none" key="none" disabled>
                    <span className="defaultSelected"> Select Any</span>
                  </MenuItem>
                  <MenuItem value={'Y'} key={'Y'}>
                    Yes
                  </MenuItem>
                  <MenuItem value={'N'} key={'N'}>
                    No
                  </MenuItem>
                </Select>
              </FormControl>
            </ErrorTooltip>
          </div>
        </>
      );
    },
    fieldHeader: ({values = {}, handleChange, touched = {}, errors = {}, setFieldValue}) => {
      return (
        <>
          <div key={currField} className="format-field">
            <ErrorTooltip
              title={errors['fieldHeader' + currField] ? errors['fieldHeader' + currField] : ''}
            >
              <TextField
                margin="dense"
                type="text"
                variant="outlined"
                placeholder={`Enter Field Header`}
                InputLabelProps={{
                  shrink: true,
                }}
                name={'fieldHeader' + currField}
                value={values['fieldHeader' + currField] ? values['fieldHeader' + currField] : ''}
                onChange={(e) => {
                  setFieldValue('fieldHeader' + currField, e.target.value);
                }}
                error={touched['fieldHeader' + currField] && errors['fieldHeader' + currField]}
              />
            </ErrorTooltip>
          </div>
        </>
      );
    },
    sortSeqNum: ({values = {}, handleChange, touched = {}, errors = {}, setFieldValue}) => {
      return (
        <>
          <div key={currField} className="format-field">
            <ErrorTooltip
              title={errors['sortSeqNum' + currField] ? errors['sortSeqNum' + currField] : ''}
            >
              <TextField
                margin="dense"
                type="number"
                inputProps={{min: 1}}
                variant="outlined"
                placeholder={`Enter Sort Seq`}
                InputLabelProps={{
                  shrink: true,
                }}
                name={'sortSeqNum' + currField}
                value={
                  values['sortSeqNum' + currField] ? Number(values['sortSeqNum' + currField]) : ''
                }
                onChange={(e) => {
                  setFieldValue('sortSeqNum' + currField, e.target.value);
                }}
                error={touched['sortSeqNum' + currField] && errors['sortSeqNum' + currField]}
              />
            </ErrorTooltip>
          </div>
        </>
      );
    },
    sortType: ({values = {}, touched = {}, errors = {}, setFieldValue, disabled = false}) => {
      return (
        <>
          <div key={currField} className="format-field">
            <ErrorTooltip
              title={errors['sortType' + currField] ? errors['sortType' + currField] : ''}
            >
              <FormControl margin="dense" variant="outlined" fullWidth>
                <Select
                  name={'sortType' + currField}
                  className="select-gender"
                  disabled={!values['sortSeqNum' + currField]}
                  value={values['sortType' + currField] || 'none'}
                  onChange={(e) => {
                    setFieldValue('sortType' + currField, e.target.value);
                  }}
                  error={touched['sortType' + currField] && errors['sortType' + currField]}
                >
                  <MenuItem value="none" key="none" disabled>
                    <span className="defaultSelected"> Select Any</span>
                  </MenuItem>
                  <MenuItem value={'ASC'} key={'ASC'}>
                    Ascending
                  </MenuItem>
                  <MenuItem value={'DESC'} key={'DESC'}>
                    Descending
                  </MenuItem>
                </Select>
              </FormControl>
            </ErrorTooltip>
          </div>
        </>
      );
    },
  };
}
